$(document).ready(function(){

    //array of related videos
    let relatedVideosArr = [];
    let relatedVideosPlaylistCache = null;
    let relatedVideosPopupHeading = (window.theme && window.theme.strings && window.theme.strings.codectible && window.theme.strings.codectible.videoRelatedHeading) || 'Related Videos';
    let relatedVideosPopupData = {
      title: relatedVideosPopupHeading,
      title2: relatedVideosPopupHeading,
      mobileTitle: relatedVideosPopupHeading
    };

  

  function initRelatedVideos() {
  
    $('.js-related-videos-section').each(function () {
      var $parent = $(this);
      

      let searchQuery = $parent.data('search');

      var $latestVideoSection = false;
      if (searchQuery == "codectible-video" || searchQuery == "disruptor-video") {
        $latestVideoSection = $('.js-codectible-latest-video-section');
      }
      

      $.ajax({
        url: window.Shopify.routes.root + 'search?view=videoBlog-ajax&type=article&q=' + searchQuery,
        dataType: 'json',
        success: function(data){
          console.log(data);
          data = data.results;
          if ($latestVideoSection) {
            buildLatestVideoSection(data, $latestVideoSection);
          }
          buildRelatedVideosSection(data, $parent);
        },
        error: function(err){
          console.log(err)
        }
      })
   })
  }

  function buildLatestVideoSection(data, $parent){
    if($parent.length == 0 || !data || data.length == 0) {
      $parent.hide();
      return data;
    }


    data.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.published_at) - new Date(a.published_at);
    });

    //get 1st element after sorting
    let latestVideo = data.shift();

    console.log(latestVideo);

    let videoProps = "autoplay playsinline loop muted controls"

    let $videoContainer = $parent.find('.js-codectible-latest-video-container');
    $videoContainer.append(`<video class="mobile-hide codectible-latest-video" src="${latestVideo.video}" ${videoProps} />`);
    $videoContainer.append(`<video class="desktop-hide codectible-latest-video" src="${latestVideo.mobile_video}" ${videoProps} />`);
    $videoContainer.addClass('video-loaded')
    
  }

  function withRelatedVideoPopupReady(callback) {
    if (window.theme && window.theme.whenRelatedVideoPopupReady) {
      window.theme.whenRelatedVideoPopupReady(callback);
      return;
    }
    if (window.customElements && window.customElements.get && window.customElements.get('related-video-popup')) {
      if (typeof callback === 'function') callback();
    }
  }

  function getRelatedVideoPopupSelector($trigger, $wrapper) {
    if ($trigger && $trigger.length && $trigger.data('src')) {
      return $trigger.data('src');
    }
    if ($wrapper && $wrapper.length && $wrapper.data('open-popup')) {
      return $wrapper.data('open-popup');
    }
    return '#product-related-video-player-popup';
  }

  function getRelatedVideoPlaylist() {
    if (relatedVideosPlaylistCache) return relatedVideosPlaylistCache;
    relatedVideosPlaylistCache = [];

    if(!relatedVideosArr || relatedVideosArr.length == 0) return relatedVideosPlaylistCache;

    for(let i = 0; i < relatedVideosArr.length; i++){
      let item = relatedVideosArr[i];
      var video = item.video
      var thumb = item.thumb
      var category = item.category
      var title = item.title
      var video_type = item.videoType
      
      var data = {
        name: title,
        description: category,
        video_type: video_type,
        autoplay: true,
        sources: [
          { src: video, type: 'video/mp4'}
        ],
        aspectRatio: "16:9",
        thumbnail:[
          { src: thumb }
        ]
      }

      relatedVideosPlaylistCache.push(data);
    }

    return relatedVideosPlaylistCache;
  }

  function getRelatedVideoData($trigger) {
    if (!$trigger || !$trigger.length) {
      return relatedVideosArr && relatedVideosArr.length ? relatedVideosArr[0] : null;
    }

    var video = $trigger.data('video');
    if (!video) {
      return relatedVideosArr && relatedVideosArr.length ? relatedVideosArr[0] : null;
    }

    if (relatedVideosArr && relatedVideosArr.length) {
      for (var i = 0; i < relatedVideosArr.length; i++) {
        if (relatedVideosArr[i].video === video) return relatedVideosArr[i];
      }
    }

    return { video: video };
  }

  function openRelatedVideoPopup(videoData, $trigger) {
    if (!videoData || !videoData.video) return;

    var $wrapper = $trigger && $trigger.length ? $trigger.closest('.js-related-videos-section') : null;
    var popupSelector = getRelatedVideoPopupSelector($trigger, $wrapper);

    withRelatedVideoPopupReady(function() {
      var popup = document.querySelector(popupSelector);
      if (!popup || !popup.open) return;

      if (popup.initPlaylist && !popup.dataset.playlistInitialized) {
        var playlist = getRelatedVideoPlaylist();
        if (playlist.length) {
          popup.initPlaylist(playlist, relatedVideosPopupData);
          popup.dataset.playlistInitialized = 'true';
        }
      }

      popup.open(videoData.video);
    });
  }

  function bindRelatedVideoPopupClicks() {
    $(document).off('click.relatedVideoPopup', '.js-product-related-video-play-icon');
    $(document).on('click.relatedVideoPopup', '.js-product-related-video-play-icon', function(e){
      e.preventDefault();
      e.stopPropagation();

      var $trigger = $(this);
      var videoData = getRelatedVideoData($trigger);
      openRelatedVideoPopup(videoData, $trigger);
    });
  }

  function buildRelatedVideosSection(data, $wrapper){
    var items = data
    if(!items || items.length == 0){
      return;
    }

    relatedVideosArr = [];
    relatedVideosPlaylistCache = null;
    var popupSelector = $wrapper.data('open-popup') || '#product-related-video-player-popup';

    let priorityItems = [];
    let itemsCopy = [];

    //split array to priority and non priority

    for(let i = 0; i < items.length; i++){
      if(items[i].priority){
        priorityItems.push(items[i]);
      }else{
        itemsCopy.push(items[i]);
      }

      if(items[i].watch){
        initProductWatchIcon(items[i]);
      }
    }

    //sort by date
    itemsCopy.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.published_at) - new Date(a.published_at);
    });
    //sort by date;
    priorityItems.sort(function(a,b){
      return new Date(b.published_at) - new Date(a.published_at);
    });

    //merge two arrays priority first
    items = [...priorityItems, ...itemsCopy];

    console.log('related videos: ', items);

    var $relatedVideosSliderContainer = $wrapper.find('.product-related-videos-slider');

    //add articles to the slider
    for(var i = 0; i < items.length; i++){
      var article = items[i];
      var template = $(`<div class="product-related-information" >
        <a href="${article.url}">
          <div class="product-related-information-image-container">
            <img alt="${article.title}" src="${article.thumb}">
            <span data-src="${popupSelector}"
              data-title="${article.title}"
              data-thumb="${article.thumb}"
              data-category="${article.category}"
              data-video-type="${article.videoType}"
              data-video="${article.video}" class="product-related-video-play-icon js-product-related-video-play-icon">
              <span class="oi" data-glyph="play-circle"></span>
            </span>
          </div>
          <div class="product-related-information-text">
            <span class="product-related-information-category">${article.category}</span>
            <h4 class="product-related-information-title">${article.title}</h4>
          </div>
        </a>

      </div>`)

      $relatedVideosSliderContainer.append(template);
      relatedVideosArr.push(article);
    }

    let slickSettings = {
      accessibility: true,
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      prevArrow:
        '<a aria-label="Previous" class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      nextArrow:
        '<a aria-label="Next" class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    }

    let initSlick = function() {
      if (!$relatedVideosSliderContainer.length || $relatedVideosSliderContainer.hasClass('slick-initialized')) {
        return;
      }
      $relatedVideosSliderContainer.on('init', function(){
        $wrapper.addClass('is-initializing');
        if($(window).width() > 768 && $relatedVideosSliderContainer.hasClass('slick-initialized')){
          $(window).trigger('resize');
        }
        setTimeout(function(){
          $wrapper.removeClass('is-initializing');
          $wrapper.addClass('initialized');
          if($(window).width() > 768 && $relatedVideosSliderContainer.hasClass('slick-initialized')){
            $relatedVideosSliderContainer.slick('refresh')
          }
        }, 2000)
      })

      $relatedVideosSliderContainer.slick(slickSettings)
    };

    if (window.theme && window.theme.whenSlickReady) {
      window.theme.whenSlickReady(initSlick);
    } else if ($.fn && $.fn.slick) {
      initSlick();
    }

    $(window).on('resize', throttle(function() {
      if( $(window).width() > 768 &&  !$relatedVideosSliderContainer.hasClass('slick-initialized')) {
            if (window.theme && window.theme.whenSlickReady) {
              window.theme.whenSlickReady(initSlick);
            } else if ($.fn && $.fn.slick) {
              initSlick();
            }
      }
    }, 500));

    $wrapper.show();

  }

  function init(){
    bindRelatedVideoPopupClicks();
    //initRelatedVideos();
  }
  

  init();
})


var Codectible = (function() {
  const url = window.theme.apiUrl;

  function init(){
    initEventListeners();
  }

  function initEventListeners(){
    $('[data-codectible-follow-button]').on('click.codectible', handleFollowClick)

    $('[data-codectible-unfollow-button]').on('click.codectible', handleUnfollowClick)
  }


  function handleFollowClick(event){
    //let $this = $(this);
    event.preventDefault();
    $this = $(event.currentTarget);

    let data = {
      customerId: $this.data('customer'),
      codectibleId: $this.data('id')
    }

    let successCb = function(data){
      console.log('Follow Successful', data);
      $this.addClass('following');
      $this.removeAttr('data-codectible-follow-button');
      $this.attr('data-codectible-unfollow-button', "");
      $this.off('click.codectible');
      $this.on('click.codectible', handleUnfollowClick)
      updateFollowersCount(data.followersCount); 
    }

    let errCb = function(error){
      console.log("follow error: ", error)
    }

    codectibleFollow(data, successCb, errCb, null)
  }

  function handleUnfollowClick(event){
    event.preventDefault();
    $this = $(event.currentTarget);

    let data = {
      customerId: $this.data('customer'),
      codectibleId: $this.data('id')
    }

    let successCb = function(data){
      console.log('Unfollow Successful', data);
      $this.removeClass('following');
      $this.removeAttr('data-codectible-unfollow-button');
      $this.attr('data-codectible-follow-button', "");
      $this.off('click.codectible');
      $this.on('click.codectible', handleFollowClick)
      updateFollowersCount(data.followersCount);
    }

    let errCb = function(error){
      console.log("unfollow error: ", error)
    }

    codectibleUnfollow(data, successCb, errCb, null)
  }

  function codectibleFollow(data, cb, errCb, completeCb){
    $.ajax({
      type: "POST",
      url: url + "/api/codectible/follow",
      data: data,
      success: function (data) {
        cb(data);
      },
      error: function (err) {
        console.log("error:", err);
        errCb(err);
      },
      complete: function () {
        if (completeCb instanceof Function) {
          completeCb();
        }
      },
    });
  }

  function codectibleUnfollow (data, cb, errCb, completeCb){
    //vars - codectibleId, customerId
      $.ajax({
      type: "POST",
      url: url + "/api/codectible/unfollow",
      data: data,
      success: function (data) {
        cb(data);
      },
      error: function (err) {
        console.log("error:", err);
        errCb(err);
      },
      complete: function () {
        if (completeCb instanceof Function) {
          completeCb();
        }
      },
    });
  }

  function updateFollowersCount(count){
    let $container = $('.js-codectible-followers-count');
    if(count < 20){ 
      $container.hide();
    }else{
      $container.show(); 
    }
    $container.text(count);
  }

  init();

})();

//codectible newsletter button
document.querySelector('.js-codectible-newsletter-subscribe').addEventListener('click', function (){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Rqa67E']);
});
